import { render, staticRenderFns } from "./EvaluateSampleUpdate.vue?vue&type=template&id=137f95fb&scoped=true"
import script from "./EvaluateSampleUpdate.vue?vue&type=script&lang=js"
export * from "./EvaluateSampleUpdate.vue?vue&type=script&lang=js"
import style0 from "./EvaluateSampleUpdate.vue?vue&type=style&index=0&id=137f95fb&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "137f95fb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('137f95fb')) {
      api.createRecord('137f95fb', component.options)
    } else {
      api.reload('137f95fb', component.options)
    }
    module.hot.accept("./EvaluateSampleUpdate.vue?vue&type=template&id=137f95fb&scoped=true", function () {
      api.rerender('137f95fb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/schoolconfig/EvaluateSampleUpdate.vue"
export default component.exports